import React, { useEffect } from 'react';
import { CheckCircle, Phone, Mail, Calendar, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { LogoOption1 } from '../components/LogoOptions';
import { Link } from 'react-router-dom';

export const ThankYou = () => {
  // Fire Google Ads conversion event when page loads
  useEffect(() => {
    if (window.gtag) {
      // Send conversion event to Google Ads
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18192202692',
        'value': 1.0,
        'currency': 'USD',
        'transaction_id': ''
      });
      
      // Also send as a custom event for tracking
      window.gtag('event', 'form_submission', {
        'event_category': 'engagement',
        'event_label': 'lead_form_submitted'
      });
      
      console.log('Google Ads conversion events fired');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Breadcrumb */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 py-3 text-sm">
            <Link 
              to="/" 
              className="flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors"
            >
              <Home className="w-4 h-4 mr-1" />
              Home
            </Link>
            <span className="text-gray-400">/</span>
            <span className="text-gray-600 font-medium">Thank You</span>
          </div>
        </div>
      </nav>

      <div className="flex items-center justify-center px-4 py-12">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <LogoOption1 className="h-16" />
        </div>

        {/* Success Card */}
        <Card className="border-2 border-green-200 shadow-2xl">
          <CardContent className="p-8 sm:p-12 text-center">
            {/* Success Icon */}
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>

            {/* Main Message */}
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Thank You!
            </h1>
            
            <p className="text-xl text-gray-600 mb-6">
              Your request has been successfully submitted.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mb-8 text-left">
              <h2 className="font-semibold text-gray-900 mb-2">What Happens Next?</h2>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>I&apos;ll personally review your information</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>You&apos;ll typically hear from me within 24 hours (usually much sooner)</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>We&apos;ll discuss your specific situation and goals</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>No pressure—just honest guidance and clear answers</span>
                </li>
              </ul>
            </div>

            {/* Alternative Contact Methods */}
            <div className="border-t border-gray-200 pt-8 mb-8">
              <p className="text-gray-600 mb-6">
                <strong>Prefer to talk right now?</strong> I&apos;m here to help.
              </p>

              <div className="grid sm:grid-cols-2 gap-4">
                <Button
                  size="lg"
                  className="bg-blue-600 hover:bg-blue-700"
                  onClick={() => window.location.href = 'tel:+17203078711'}
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Call (720) 307-8711
                </Button>

                <Button
                  size="lg"
                  variant="outline"
                  onClick={() => window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3-Q5PB32iYcYOFy0AfHcJQEewh-0EC12gx8qLVXkzCXMl3Ok1RTHDMZLWUv-lyg1PdwLj-W9SR', '_blank')}
                >
                  <Calendar className="w-5 h-5 mr-2" />
                  Schedule a Call
                </Button>
              </div>

              <div className="mt-4">
                <a 
                  href="mailto:info@milehighreverse.com"
                  className="inline-flex items-center text-blue-600 hover:text-blue-700"
                >
                  <Mail className="w-4 h-4 mr-2" />
                  info@milehighreverse.com
                </a>
              </div>
            </div>

            {/* Return to Homepage */}
            <Button
              variant="ghost"
              onClick={() => window.location.href = '/'}
              className="text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Return to Homepage
            </Button>
          </CardContent>
        </Card>

        {/* Additional Trust Elements */}
        <div className="text-center mt-8 text-sm text-gray-600">
          <p>
            Peter Andrew S., CPA & Licensed Mortgage Specialist | NMLS #2575736
          </p>
          <p className="mt-2">
            Serving Colorado homeowners 62+ with tax-efficient reverse mortgage solutions
          </p>
        </div>
      </div>
      </div>
    </div>
  );
};
